export default __webpack_public_path__ + "img/27e30aa52be47ab1820414e6a74c8406.png";